@if (device) {
  <div class="d-flex flex-column h-100">
    <nav class="navbar navbar-expand navbar-main p-0 z-1">
      <div class="container-fluid gap-2">
        <a class="navbar-brand d-flex align-items-center d-flex gap-2 align-items-center" routerLink="/">
          <i class="bi-arrow-left"></i>
          <span>Leave the Lab</span>
        </a>
        <app-device-list-dropdown
          [device]="device"
          (selectDevice)="onSelectDevice($event)"
          (backToDashboard)="onBackToDashboard()"
        ></app-device-list-dropdown>
      </div>
    </nav>
    <div class="flex-grow-1 overflow-auto">
      <div class="container h-100">
        <!-- Actions -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <h4>Actions</h4>
            <div class="d-flex gap-2">
              @if (showBrakeControlInNavbar$ | async) {
                <span>
                  <app-brake-control [device]="device"></app-brake-control>
                </span>
              }
              <span>
                <button type="button" class="btn btn-danger" (click)="onStop()">QUICK STOP</button>
              </span>
              <span>
                <app-reset-fault-button [device]="device" [alwaysShow]="true"></app-reset-fault-button>
              </span>
              <span>
                <app-save-to-device-button [device]="device"></app-save-to-device-button>
              </span>
              <span>
                <button type="button" class="btn btn-secondary" (click)="onFileBrowser()">FILE BROWSER</button>
              </span>
              <span>
                <app-quick-open-button [device]="device"></app-quick-open-button>
              </span>
            </div>
          </div>
        </div>
        <!-- Circulo Encoder Calibration Plot -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <h4 class="mb-3">Circulo Encoder Calibration Plot</h4>
            <div class="border p-2">
              <div style="height: 337px">
                <app-circulo-encoder-calibration-plot
                  [data]="encoderCalibrationPlotData"
                  [maxPermissiblePhaseError]="256"
                  [maxValuePercentageIndex]="200"
                >
                </app-circulo-encoder-calibration-plot>
              </div>
            </div>
          </div>
        </div>
        <!-- Circulo Encoder Calibration Circle -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <h4 class="mb-3">Circulo Encoder Calibration Circle</h4>
            <div class="border p-3">
              <div class="m-auto" style="width: 256px; height: 256px">
                <app-distance-circle
                  class="d-absolute w-100 h-100"
                  [distances]="distances"
                  [position]="12000"
                  [resolution]="4096"
                >
                </app-distance-circle>
              </div>
            </div>
          </div>
        </div>
        <!-- External Scaled Measurement -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <h4>External Scaled Measurement</h4>
            <app-device-parameter-form [parameters$]="externalScaledMeasurementParameters$"></app-device-parameter-form>
          </div>
        </div>
        <!-- Cogging Torque Compensation -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <app-cogging-torque-compensation [device]="device"></app-cogging-torque-compensation>
          </div>
        </div>
        <!-- System Identification -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <app-system-identification [device]="device"></app-system-identification>
          </div>
        </div>
        <!-- Offset Detection -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <app-offset-detection [device]="device"></app-offset-detection>
          </div>
        </div>
        <!-- Position Controller Tuning -->
        @if (positionTuningController$ | async; as tuningController) {
          <div class="row p-3 my-3 border bg-white shadow">
            <div class="col">
              <app-position-controller-tuning title="Position Controller Tuning" [tuningController]="tuningController">
              </app-position-controller-tuning>
            </div>
          </div>
        }
        <!-- Velocity Controller Tuning -->
        @if (velocityTuningController$ | async; as tuningController) {
          <div class="row p-3 my-3 border bg-white shadow">
            <div class="col">
              <app-velocity-controller-tuning title="Velocity Controller Tuning" [tuningController]="tuningController">
              </app-velocity-controller-tuning>
            </div>
          </div>
        }
        <!-- Torque Controller Tuning -->
        @if (torqueTuningController$ | async; as tuningController) {
          <div class="row p-3 my-3 border bg-white shadow">
            <div class="col">
              <app-torque-controller-tuning title="Torque Controller Tuning" [tuningController]="tuningController">
              </app-torque-controller-tuning>
            </div>
          </div>
        }
        <!-- Motion Controller -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <div class="row">
              <div class="col">ENABLE MOTION CONTROLLER</div>
              <div class="col text-end">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="motionControllerFilter"
                    [(ngModel)]="motionControllerFilter"
                  />
                  <label class="form-check-label" for="motionControllerFilter">Filter</label>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <button type="button" class="btn btn-primary w-100" (click)="onEnablePositionController()">
                  POSITION
                </button>
              </div>
              <div class="col">
                <button type="button" class="btn btn-primary w-100" (click)="onEnableVelocityController()">
                  VELOCITY
                </button>
              </div>
              <div class="col">
                <button type="button" class="btn btn-primary w-100" (click)="onEnableTorqueController()">TORQUE</button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <button type="button" class="btn btn-danger w-100" (click)="onDisableMotionController()">
                  DISABLE MOTION CONTROLLER
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Signal Generators -->
        <div class="row p-3 my-3 border bg-white shadow">
          <div class="col">
            <h4>Signal Generators</h4>
            @if (hasValidSensorConfiguration$ | async) {
              @for (tuningController of tuningControllers$ | async; track tuningController.id) {
                <div class="my-3">
                  <h5 class="mb-3">{{ tuningController.name }}</h5>
                  <app-signal-generator
                    *appIsPdoControlMode
                    [tuningController]="tuningController"
                  ></app-signal-generator>
                </div>
              }
            } @else {
              The selected device has invalid or no sensor configurations.
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
